// Split out of JointAngleGoalAnnotation.tsx (react-refresh/only-export-components)
// — a data constant, not a component. Behavior unchanged.

/**
 * Joint names from backend JOINT_DEFINITIONS (joint_angle_goal_evaluation.py:34-48).
 * Functional variants (lead_/trail_) resolve at evaluation time.
 * Listed in a coach-friendly order: functional first, then anatomical.
 */
export const JOINT_NAMES: Array<{ value: string; label: string; group: string }> = [
  // Functional (handedness-aware) — preferred for asymmetric movements
  { value: 'lead_knee', label: 'Lead Knee', group: 'Functional' },
  { value: 'trail_knee', label: 'Trail Knee', group: 'Functional' },
  { value: 'lead_hip', label: 'Lead Hip', group: 'Functional' },
  { value: 'trail_hip', label: 'Trail Hip', group: 'Functional' },
  { value: 'lead_elbow', label: 'Lead Elbow', group: 'Functional' },
  { value: 'trail_elbow', label: 'Trail Elbow', group: 'Functional' },
  { value: 'lead_shoulder', label: 'Lead Shoulder', group: 'Functional' },
  { value: 'trail_shoulder', label: 'Trail Shoulder', group: 'Functional' },
  { value: 'lead_ankle', label: 'Lead Ankle', group: 'Functional' },
  { value: 'trail_ankle', label: 'Trail Ankle', group: 'Functional' },
  // Anatomical (fixed side)
  { value: 'left_knee', label: 'Left Knee', group: 'Anatomical' },
  { value: 'right_knee', label: 'Right Knee', group: 'Anatomical' },
  { value: 'left_hip', label: 'Left Hip', group: 'Anatomical' },
  { value: 'right_hip', label: 'Right Hip', group: 'Anatomical' },
  { value: 'left_elbow', label: 'Left Elbow', group: 'Anatomical' },
  { value: 'right_elbow', label: 'Right Elbow', group: 'Anatomical' },
  { value: 'left_shoulder', label: 'Left Shoulder', group: 'Anatomical' },
  { value: 'right_shoulder', label: 'Right Shoulder', group: 'Anatomical' },
  { value: 'left_ankle', label: 'Left Ankle', group: 'Anatomical' },
  { value: 'right_ankle', label: 'Right Ankle', group: 'Anatomical' },
];
